import { FormEvent, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../store/auth";

export function LoginPage() {
  const user = useAuth((s) => s.user);
  const login = useAuth((s) => s.login);
  const error = useAuth((s) => s.error);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) {
    return <Navigate to={user.role === "admin" ? "/admin" : "/"} replace />;
  }

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
    } catch {
      /* error in store */
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-hero">
      <div className="panel login-card stack">
        <div className="brand-hero">
          <div className="logo-lg" aria-hidden>
            R
          </div>
          <h1>Receipt Matching</h1>
          <p className="muted" style={{ marginTop: "0.4rem" }}>
            Link company card spend to receipts — on any phone.
          </p>
        </div>

        <form className="stack" onSubmit={onSubmit}>
          <div className="field">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="field">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <div className="alert">{error}</div>}
          <button className="btn btn-primary btn-block" disabled={busy} type="submit">
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
